import { cardComissaoStyles } from './CardComissao.styles'

export function cardComissaoIO() {
  return {
    styles: cardComissaoStyles
  }
}

export type CardComissaoIO = ReturnType<typeof cardComissaoIO>
